
import React from 'react';
import { NavLink } from 'react-router-dom';
import './style.css';

const MobileNav = ({ navOpen, closeNav }) => {
  return (
    <div className={`mobile__nav ${navOpen ? 'open' : ''}`}>
      <button onClick={closeNav} className="close-btn">✕</button>
      <ul className="mobile__nav-links">
        <li>
          <NavLink to="/" onClick={closeNav}>Home</NavLink>
        </li>
        <li>
          <NavLink to="/projects" onClick={closeNav}>Projects</NavLink>
        </li>
        <li>
          <NavLink to="/gallery" onClick={closeNav}>Gallery</NavLink>
        </li>
        <li>
          <NavLink to="/contacts" onClick={closeNav}>Contacts</NavLink>
        </li>
      </ul>
    </div>
  );
};

export default MobileNav;